// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__18A3g","title":"InfoRow_title__3rQr2"};